import { render, staticRenderFns } from "./PrDevice.vue?vue&type=template&id=3c5691c7&scoped=true&"
import script from "./PrDevice.vue?vue&type=script&lang=js&"
export * from "./PrDevice.vue?vue&type=script&lang=js&"
import style0 from "./PrDevice.vue?vue&type=style&index=0&id=3c5691c7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c5691c7",
  null
  
)

export default component.exports